import React, { useEffect } from "react";
import "./Solution2.css";
import Header from "../Home/Header";
import Footer from "../Home/Footer";
const Loganalytic = () => {
  useEffect(() => {
    window.scrollTo(0, 0);  
  }, []);

  return (
    <>
      <Header />
      <div className="resilience-container">
        {/* Hero Section */}
        <div className="hero-section">
          <div className="hero-content">
            <div class="backup-container">
              <a href="/solutions#Infrastructure" class="backup-text">
                Solution
              </a>
              <p class="backup-text">/Log analytic​​​</p>
            </div>

            <div className="hero-wrapper">
              <div className="hero-text-container">
                <div className="hero-text-content">
                  <h1 className="hero-title">
                    <span className="hero-title-main">Log analytic​​​</span>
                  </h1>
                  <p className="hero-subtitle">
                    Unlock Insights and Drive Operational Excellence with Our
                    Elastic Log Analytics Solutions​.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content">
          <div className="introduction-text">
            <b>Introduction:</b> In the digital era, logs are not just data—they
            are the key to understanding your system's health, behavior, and
            performance. Our Elastic Log Analytics solutions harness the power
            of the Elastic Stack to offer you real-time insights, enhanced
            search capabilities, and comprehensive data analysis.​​
          </div>

          <h2 className="section-title">Why Elastic Log Analytics?​​​​​</h2>
          <div class="boost-productivity-container">
            <p class="boost-productivity-text">
              <b>Centralized Logging </b>: Aggregate logs from various sources
              into a single, searchable repository.
            </p>
            <p class="boost-productivity-text">
              <b>Real-Time Analysis </b>: Process and visualize logs in real
              time to detect anomalies, trends, and patterns.​
            </p>

            <p class="boost-productivity-text">
              <b>Scalability </b>: Effortlessly scales with your data volume and
              complexity, from a handful of logs to billions of events per
              day.​​
            </p>
            <p class="boost-productivity-text">
              <b>Powerful Search </b>: Elastic's renowned full-text search
              capabilities let you query your logs just like you would search
              the web.​​​​
            </p>
            <p class="boost-productivity-text">
              <b>Actionable Insights </b>: Turn logs into actionable insights
              with machine learning features for anomaly detection and
              forecasting.​​
            </p>
            <p>
              <h2>Core Features</h2>
              <br />
            </p>
            <p class="boost-productivity-text">
              <b>Data Ingestion </b>: Supports a variety of formats and sources,
              ensuring all data is captured and indexed.​​​​
            </p>
            <p class="boost-productivity-text">
              <b>Flexible Data Enrichment </b>: Enhance your logs with
              additional metadata for more context and deeper analysis.​
            </p>
            <p class="boost-productivity-text">
              <b>Intuitive Dashboards </b>: Customizable Kibana dashboards
              provide at-a-glance insights and in-depth analysis.​​
            </p>
            <p class="boost-productivity-text">
              <b>Alerting and Monitoring </b>: Get notified about issues before
              they impact your business with real-time alerts.​​
            </p>
            <p class="boost-productivity-text">
              <b>Security and Compliance </b>: Keep your log data secure and
              meet regulatory compliance with role-based access control and data
              encryption.​​
            </p>
            <h2>Our Solutions</h2>
            <br />
            <p class="boost-productivity-text">1.Infrastructure Monitoring​​</p>
            <p class="boost-productivity-text">
              2.Application Performance Monitoring​
            </p>
            <p class="boost-productivity-text">
              3.Security Information and Event Management​​
            </p>
            <p class="boost-productivity-text">
              4.Custom Log Analytics Solutions
            </p>
            <p class="boost-productivity-text">
              ​ 5.Consulting and Implementation Services
            </p>
            <p class="boost-productivity-text">
              "Explore the depth of your data with our Elastic Log Analytics
              solutions. Contact us for a demo and discover how you can
              transform logs into strategic assets."​{" "}
            </p>
            <br />
          </div>
          <div class="button-container">
            <a href="/contactus?subject=Log%20analytic" class="contact-button">
              Contact Us
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Loganalytic;
